/** Refine I18nProvider adapter поверх react-i18next. */

import type { I18nProvider } from "@refinedev/core";
import i18n from "@/i18n";

export const i18nProvider: I18nProvider = {
  translate: (key, options) => i18n.t(key, options as never) as unknown as string,
  changeLocale: (lang) => i18n.changeLanguage(lang),
  getLocale: () => i18n.language,
};
